<template>
  <div class="bgf5">
    <iHeader />
    <iNav />
    <iClassify :active="5" AllActive />
    <iRightFixedBox />
    <iPageTitle :text="pageTitle" />
    <div class="adlist">
      <HomeAdCarousel ref="BrandAdCarousel" />
    </div>
    <div class="list">
      <img class="logo" src="../../assets/brand.png" />
    </div>
    <div class="list">
      <van-list :finished="dataState.finished" :finished-text="dataList&&dataList.length>formData.pagesize?lang.List.Finished:''"
        @load="onLoad">
        <div class="list-item" v-for="(item) in dataList" :key="item.Id">
          <div class="brand-item">
            <van-image :src="_getPic(item.Logo)" lazy-load fit="scale-down" style="height:100%; width:100%;"
              @click.stop='_jump(Enum_LinkTypeCode.DtoProductList,`{"brandId":"${item.Id}","name":"${item.Name}"}`,"_blank")' />
          </div>
          <div class="hotgoods-small">
            <div v-for="(subItem,i) in productList" :key="subItem.Id" v-if="subItem.Brand.Id == item.Id">
              <product-list-item :ref="'p_'+subItem.Id" style="width:200px; padding-top:50px;" :product="_itemToGoods(subItem)"
                @showProduct="()=>{showRouter(subItem)}" fromPage="brand" goods-type="HomeSmallGoods" />
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <iFooter />
  </div>
</template>

<script>
  import iHeader from "@/components/Header";
  import iNav from "@/components/Nav";
  import iClassify from "@/components/Classify";
  import iPageTitle from "@/components/PageTitle";
  import iFooter from "@/components/Footer";
  import iRightFixedBox from "@/components/RightFixedBox";
  import { BaseMixin } from "../../mixins/BaseMixin";
  import HomeAdCarousel from "@/views/home/HomeAdCarousel";

  export default {
    mixins: [BaseMixin],
    components: {
      iHeader,
      iNav,
      iFooter,
      iRightFixedBox,
      iClassify,
      iPageTitle,
      HomeAdCarousel
    },

    data() {
      return {
        pageTitle: ["精选大牌"],
        dataList: [],
        brandIdList: [],
        productList: [],
        dataState: {
          //刷新中
          refreshing: false,
          //加载中
          loading: false,
          //加载所有数据
          finished: false
        },
        //请求参数
        formData: {
          pageindex: 0,
          pagesize: 10
        },
        url: {
          brandList: "/clientapi_brand/Brand/Pagging",
          productList: "/api_goods/GoodsSku/ListForCustomer",
          getAdvertisementInfos: "/api_basedata/HomePage/GetAdvertisementInfos?enumTerminalType=1&codes=brand7_1", //即将到货列表推荐广告图
        }
      };
    },
    mounted() {

    },
    created() {
      this.getAdvertisementInfos()
    },
    methods: {
      showRouter: function (item) {
        this._jump(this.Enum_LinkTypeCode.ProductDetails, item.Id, "_blank");
      },


      //加载广告
      async getAdvertisementInfos() {
        let res = await this.getAction(`${this.url.getAdvertisementInfos}`);
        if (res.IsSuccess) {
          if (this.$refs["BrandAdCarousel"])
            this.$refs["BrandAdCarousel"].init(res.Data);
        }
      },

      //加载数据
      async onLoad() {
        if (this.formData.pageindex == 0) {
          this.dataState.finished = false;
        }
        this.formData.pageindex = this.formData.pageindex + 1;
        await this.loadData();
      },

      async loadData() {
        this.dataState.loading = true;
        this.$hys.openLoading();
        let res = await this.getAction(this.url.brandList, {
          page: this.formData.pageindex,
          pagesize: this.formData.pagesize
        });
        this.dataState.loading = false;
        this.$hys.clearLoading();
        this.dataState.finished = true;
        this.dataList = this.dataList.concat(res.Data);
        this.dataList.forEach(async o => {
          let productRes = await this.getAction(this.url.productList, {
            page: 1,
            pagesize: 3,
            brandId: o.Id
          });
          // this.productList = productRes.Data
          this.productList = this.productList.concat(productRes.Data);
          // console.log(productRes.Data)
        });
      }
    }
  };
</script>

<style lang="less" scoped>
  .adlist {
    margin-left: calc((99vw - 1200px) / 2);
    padding-top: 20px;
    width: 1200px;
    max-width: 1200px;
  }

  .list {
    margin-left: calc((99vw - 1200px) / 2);
    padding-top: 20px;
    width: 1200px;
    max-width: 1200px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;

    .logo {
      // margin-left: calc(850px / 2);
      margin: 40px 0 20px 0;
      height: 30px;
      // width: 300px;

    }

    .list-item {
      text-align: center;
      width: 100%;
      cursor: pointer;
      display: flex;
      flex-direction: row;


      >.brand-item {
        width: 541px;
        height: 278px;
        background: white;
        border-radius: 8px 0px 0px 8px;

        img {
          max-width: 541px;
          max-height: 278px;
        }
      }
    }
  }


  .hotgoods-small {
    padding-left: -50px;
    width: 658px;
    height: 278px;
    background-color: white;
    display: flex;
    flex-direction: row;
    // justify-content: space-between;
    margin-bottom: 20px;

    >div {
      position: relative;

      >div::after {
        content: "";
        background: url("../../assets/goods/strip_v.png") no-repeat center;
        background-size: cover;
        width: 1px;
        height: 300px;
        position: absolute;
        right: -50px;
        bottom: 0;
      }
    }

    >div:last-child>div::after {
      display: none !important;
    }
  }

  // .goods-item-sgoods {
  //   // min-width: 200px;
  //   // max-width: 200px;

  //   >.goods-image {
  //     margin: 0px 38px 4px 38px;
  //   }
  // }
</style>